import { Col, Container, Form, Row } from "react-bootstrap";

function Contact() {
  return (
    <section id="contact" className="container my-5">
      <Row>
        <Col>
          <img src="https://placehold.co/500" />
        </Col>
        <Col className="text-end">
          <h1>Lets get in touch</h1>
          <p>Contact us today to learn more, book a demo or get started.</p>

          <Form className="text-start">
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your name" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter email" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicMessage">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter your message"
              />
            </Form.Group>

            <button className="btn gradient" type="submit">
              Submit
            </button>
          </Form>
        </Col>
      </Row>
    </section>
  );
}

export default Contact;
